<template>
  <div>
    <!-- 宝箱开奖结果 -->
    <div class="Dialog prize-result" v-if="state.matches('participate.luckydraw.batchDraw.startBatchDraw')">
      <div class="inner">
        <div class="pic-bg"></div>
        <div class="pic-birld"></div>
        <div class="pic-cloud"></div>

        <div class="icon-close" @click="send('CLOSE')"></div>
        <div class="title"><span>宝箱开奖结果</span></div>

        <div class="inner-body">
          <p class="desc">您已走完一圈回到原点，请记得领取终极宝箱哦~</p>
          <ul class="prize-list" v-if="boxes && boxes.length==6">
            <AwardListItem :service="state.context.luckLottery[item.groupid]" v-for="item in boxes" :key="item.groupid"
                           :rank="item.rank"></AwardListItem>
          </ul>

          <div class="prize-tip">
            <p class="tip">如果继续抽奖，您将有机会获得超值礼品</p>
            <img class="prize-more" v-if="state.context.selectedMap=='junior'" src="../../../../ui/20201111king_double_eleven/assets/jxcj1.png"/>
            <img class="prize-more" v-else-if="state.context.selectedMap=='senior'" src="../../../../ui/20201111king_double_eleven/assets/jxcj-2.png"/>
            <div class="btns btns--style">
              <button class="btn-lottery" @click="send('CLICK_PRESENT',{present_rank:7})">去开启终极宝箱</button>
            </div>

            <p class="record" @click="send('FETCH_PRIZE_LIST',{showAll:true})">查看中奖纪录</p>
          </div>
        </div>
      </div>
    </div>

    <Toast toast-msg="抽奖失败请用户重试" v-if="state.matches('participate.luckydraw.batchDraw.startBatchDraw.failure.visible')"></Toast>
    <Toast toast-msg="页面繁忙，请关闭弹窗后，点击活动首页宝箱重新尝试。" v-if="state.matches('participate.luckydraw.batchDraw.startBatchDraw.couponInvale.visible')"></Toast>
  </div>

</template>

<script>
import { computed } from "@vue/composition-api"
import AwardListItem from "./AwardListItem.vue"
import Toast from "../../common/components/Toast.vue"
import * as configs from "../configs"

export default {
  name: "AwardList",
  props: ["state", "send"],
  components: {
    AwardListItem,
    Toast
  },
  setup(props) {
    const boxes = computed(() => {
      const map = props.state.context.selectedMap
      return props.state.context.gameConfig.drawGroupid[map].filter(item => item.rank <= 6)
    })

    const buy = productid => {
      props.send("PLACE_ORDER", props.state.context.gameConfig.products.find(item => item.product_id == productid))
    }

    return {
      boxes,
      buy,
      configs
    }
  }
}
</script>

<style scoped>
</style>
